<template>
  <div
    id="add-previous-evaluations-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
  >
    <a
      ref="modal"
      href="#"
      data-target="#add-previous-evaluations-modal"
      data-toggle="modal"
      data-backdrop="static"
      class="hide"
    />
    <ValidationObserver ref="formValidator">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header shadow">
            <h5 class="modal-title">
              <div class="modal-title-icon-container">
                <i class="fas fa-file" />
              </div>
              <span>Añadir Evaluación Administrada Previamente</span>
            </h5>
          </div>

          <form
            id="modal-form"
            ref="form"
            class="needs-validation"
            novalidate
            @submit.prevent="handleSubmit"
          >
            <div class="modal-body px-35 mt-4">
              <div class="tag-badge-info">
                <span class="tag-badge-title-info px-2">
                  Información General
                </span>
              </div>
              <Error v-if="errorMessage" :message="errorMessage" />
              <div class="row">
                <div class="d-flex mt-4 input-group item date mb-3 col col-12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Fecha"
                    rules="required"
                  >
                    <CustomDatePicker
                      id="txtEvaluationDate"
                      v-model="evaluationDate"
                      label="Fecha:"
                      required
                      format="dd/MMM/yyyy"
                      :max-date="disabledDatesFrom"
                      :error="errors[0]"
                      :custom-error-msg="errorMsgs['fecha']"
                    />
                  </ValidationProvider>
                </div>
                <div class="col col-12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Tipo"
                    rules="required"
                  >
                    <CustomDropDown
                      id="ddlSelectedDisciplineType"
                      v-model="disciplineTypeId"
                      label="Tipo:"
                      placeholder="Seleccionar"
                      required
                      fieldkey="id"
                      fieldname="name"
                      :options="disciplineTypeList"
                      :error="errors[0]"
                      :custom-error-msg="errorMsgs['tipo']"
                    />
                  </ValidationProvider>
                </div>
                <div class="mt-4 col col-12">
                  <ValidationProvider
                    v-slot="{ errors, dirty }"
                    name="Administrador"
                    rules="required"
                  >
                    <CustomInput
                      id="txtEvaluationAdministeredBy"
                      v-model="evaluationAdministeredBy"
                      label="Administrador:"
                      placeholder="Escribir nombre"
                      required
                      :dirty="dirty"
                      :error="errors[0]"
                      :custom-error-msg="errorMsgs['administrador']"
                    />
                  </ValidationProvider>
                </div>
                <div class="mt-4 col col-12">
                  <ValidationProvider
                    v-slot="{ errors, dirty }"
                    class="w-100"
                    name="Comentario"
                    rules="required"
                  >
                    <CustomTextArea
                      id="evaluationDescription"
                      v-model="evaluationDescription"
                      class="w-100"
                      label="Comentario:"
                      placeholder="Escribir comentario"
                      :maxlength="500"
                      :classes="['eq-field', 'text-left']"
                      required
                      :dirty="dirty"
                      :error="errors[0]"
                      :custom-error-msg="errorMsgs['comentario']"
                    />
                  </ValidationProvider>
                </div>
                <div class="col col-12">
                  <div class="tag-badge-info mt-4">
                    <span class="tag-badge-title-info px-2">Documento</span>
                  </div>
                  <div class="mt-4">
                    <div class="input-group item search mb-3">
                      <ValidationProvider
                        v-slot="{ errors }"
                        class="w-100"
                        name="Documento"
                        rules="required"
                      >
                        <CustomFileUpload
                          id="attachEvaluation"
                          v-model="attachment"
                          required
                          :error="errors[0]"
                          :custom-error-msg="errorMsgs['documento']"
                          :accept="allowedFiles"
                          @input="loadFile"
                        />
                      </ValidationProvider>
                    </div>
                    <div
                      v-if="attachment && !attachmentLoading"
                      class="item search mb-3 w-100 d-flex align-items-start"
                    >
                      <div class="w-50 mr-2">
                        <ValidationProvider
                          v-slot="{ errors }"
                          class="w-100"
                          rules="required"
                        >
                          <CustomInput
                            id="txtDocumentTitle"
                            v-model="documentTitle"
                            label="Título:"
                            required
                            :error="errors[0]"
                            :custom-error-msg="errorMsgs['tituloDocumento']"
                          />
                        </ValidationProvider>
                      </div>
                      <div class="w-50 ml-2">
                        <ValidationProvider
                          v-slot="{ errors }"
                          class="w-100"
                          rules="required"
                        >
                          <CustomDropDown
                            id="ddlSelectedDocumentType"
                            v-model="documentTypeId"
                            label="Categoría:"
                            placeholder="Seleccionar"
                            required
                            fieldkey="id"
                            fieldname="name"
                            :options="documentTypeList"
                            :error="errors[0]"
                            :custom-error-msg="errorMsgs['categoriaDocumento']"
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="group-1012 mr-2">
                <ActionButton
                  id="btnCancelEvaluation"
                  i="fas fa-times-circle"
                  data-dismiss="modal"
                  variant="btn btn-outline-danger btn-cancel danger"
                  @click="clearFormAndData()"
                >
                  Cancelar
                </ActionButton>
              </div>
              <div class="group-1012 mr-0">
                <ActionButton
                  id="btnSaveEvaluation"
                  variant="success"
                  type="submit"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </form>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<style scoped>
#add-previous-evaluations-modal .modal-dialog {
  width: 612px;
  max-width: 612px;
}

h5.modal-title {
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  font: Bold 25px/30px Lato;
  text-align: left;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
  margin-left: 2rem;
  padding-right: 1.5rem;
  padding-bottom: 0.4rem;
}
.modal-header h5 span {
  font: Bold 18px/22px Lato;
  vertical-align: sub;
  padding-left: 4px;
}
.modal-header h5.modal-title {
  margin-left: 1rem;
  font: Bold 18px/22px Lato;
}

.modal-title-icon-container {
  vertical-align: -webkit-baseline-middle;
  padding: 3px 6px;
  border-radius: 100%;
  margin-right: 10px;
  display: inline;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
}
.modal-title-icon-container i {
  padding: 0;
  font-size: 18px;
  line-height: 22px;
  color: #ff7058;
  opacity: 1;
}

.hide {
  display: none;
}

@media only screen and (max-width: 768px) {
  .modal-dialog {
    width: auto !important;
  }
}
</style>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ActionButton from '@/components/common/ActionButton';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomInput from '@/components/common/CustomInput';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomFileUpload from '@/components/common/CustomFileUpload';
import Error from '@/components/common/Error';
import store from '@/store/index';
import loading from '@/mixin/loading.mixin';
import codeService from '@/modules/common/code.api';
import categories from '@/utils/constants/categoriesFlag';
import serviceTypes from '@/utils/constants/service-types';
export default {
  name: 'AddPreviousEvaluationModal',
  mixins: [loading],
  components: {
    ActionButton,
    CustomDatePicker,
    CustomInput,
    CustomTextArea,
    CustomDropDown,
    CustomFileUpload,
    ValidationProvider,
    ValidationObserver,
    Error,
  },
  data() {
    return {
      disabledDatesFrom: new Date(),
      errorMsgs: {
        fecha: 'Fecha de evaluación es requerida (2020)',
        administrador:
          'Nombre de la persona que realizó evaluación es requerido (22127)',
        tipo: 'Favor de especificar el tipo de evaluación (2012)',
        documento: 'El documento de la evaluación es requerido (22124)',
        comentario: 'El comentario es requerido (22126)',
        tituloDocumento: 'El nombre de título es requerido',
        categoriaDocumento: 'Favor de especificar el tipo de categoría',
      },
      errorMessage: '',
      allowedFiles: '.pdf',
      attachmentLoading: false,
      documentTypeList: [
        // TODO: get from backend?
        {
          id: 1,
          name: 'Evaluación',
        },
        {
          id: 2,
          name: 'Minuta',
        },
      ],
      disciplineTypeList: [],
      evaluationDate: null,
      disciplineTypeId: null,
      evaluationDescription: null,
      evaluationAdministeredBy: null,
      documentTitle: null,
      documentTypeId: null,
      fileName: null,
      attachment: null,
    };
  },
  methods: {
    loadFile() {
      if (this.attachment) {
        self.attachmentLoading = true;
        let reader = new FileReader();
        reader.onload = (function(self) {
          self.attachmentLoading = false;
        })(this);
        reader.readAsBinaryString(this.attachment);
      } else {
        this.attachmentLoading = false;
      }
    },
    clearEvaluationData() {
      this.evaluationDate = null;
      this.disciplineTypeId = null;
      this.evaluationDescription = '';
      this.evaluationAdministeredBy = null;
      this.documentTitle = null;
      this.documentTypeId = null;
      this.fileName = null;
      this.attachment = null;
    },
    clearFormAndData() {
      this.errorMessage = null;
      this.$refs.formValidator.reset();
      this.clearEvaluationData();
      this.$emit('state', true);
    },
    async getDisciplineTypeList() {
      this.disciplineTypeList = await codeService.getDisciplineTypes({
        serviceTypeIds: [serviceTypes.EvaluacionAdicional],
        categories: [categories.unSet],
      });
    },
    async handleSubmit(e) {
      e.preventDefault();
      const isValid = await this.$refs.formValidator.validate();
      if (isValid) {
        const student = store.getters.SelectedStudent;
        let self = this;
        let formData = new FormData();
        formData.append('attachment', this.attachment);
        formData.append('evaluationDate', this.evaluationDate.toJSON());
        formData.append('disciplineTypeId', this.disciplineTypeId.id);
        formData.append('evaluationDescription', this.evaluationDescription);
        formData.append(
          'evaluationAdministeredBy',
          this.evaluationAdministeredBy
        );
        formData.append('fileName', this.attachment.name);
        formData.append(
          'documentDate',
          this.attachment.lastModifiedDate.toJSON()
        );
        formData.append('documentTypeId', this.documentTypeId.id);
        formData.append('documentTitle', this.documentTitle);
        formData.append('studentSieId', student.studentId);

        let promise = new Promise((resolve) => {
          this.$ApiPost(
            '/api/studentEvaluation/SaveStudentEvaluation',
            formData
          )
            .then((res) => {
              resolve(res.data);
              self.errorMessage = null;
              self.clearFormAndData();
              //$("#add-previous-evaluations-modal").modal('hide');

              self.$refs.modal.click();
              self.$emit('refresh', res.data);
            })
            .catch((err) => {
              self.response = err;
              if (err && err.response && err.response.data) {
                self.errorMessage = err.response.data.message;
              }
            });
        });
        return promise;
      }
    },
  },
  async mounted() {
    await this.getDisciplineTypeList();
  },
};
</script>
